import React, { useState } from 'react'
import DatePeriodSelection from './DatePeriodSelection';
import { allInteractionsApi } from "../../api";
import "react-datepicker/dist/react-datepicker.css";
import { Button } from "@material-tailwind/react";
function PodcastsActivityLogs() {
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [downloadButtonDisabled, setDownloadButtonDisabled] = useState(false);
    const formatDate = (date: Date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };
    const validateDates = () => {

        if (fromDate > toDate) {
            setDownloadButtonDisabled(true);
            return false;
        }
        setDownloadButtonDisabled(false);
        return true;
    };
    async function handleAllInteractionOnClick() {
        // if (!validateDates()) {
        //     console.log("Select correct date period");
        // } else {
        //     const response = await allInteractionsApi(formatDate(fromDate), formatDate(toDate));
        //     if (!response.ok) {
        //         throw new Error(`HTTP error! status: ${response.status}`);
        //     }

        //     const blob = await response.blob();
        //     const url = window.URL.createObjectURL(blob);
        //     const link = document.createElement("a");
        //     link.href = url;

        //     const fileName = `prompts-${formatDate(fromDate)}-${formatDate(toDate)}.csv`;
        //     link.download = fileName;
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        //     URL.revokeObjectURL(url);
        // }
    }
    return (
        <div>
            <div className="m-1 text-center flex flex-col">
                <strong className=" font-bold text-2xl	">
                    List of Podcasts User Prompts
                </strong>
                <div className="px-11">
                    <div className="py-3">
                        <span>Download an anonymized list of user prompts from podcasts search for a selected period. The report will be available as a CSV file.</span>
                    </div>
                    <div className=" flex w-full justify-center py-6">
                        <div className=" flex flex-wrap	gap-4 ">
                            <DatePeriodSelection toDate={toDate} fromDate={fromDate} setToDate={setToDate} setFromDate={setFromDate}></DatePeriodSelection>
                            <div className="flex gap-10 justify-center 	">
                                <div>
                                    <Button
                                        variant="text"
                                        className="min-w-36 h-10 font-medium bg-blue-400 text-white px-2"
                                        onClick={handleAllInteractionOnClick}
                                        disabled={downloadButtonDisabled}
                                    >
                                        Download
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default PodcastsActivityLogs